/*
 Stan strony z ofertą / rezerwacjami
 
 Redux (z użyciem redux-compact)
 https://github.com/maciekwawro/redux-compact

 */
 import { applyMiddleware, createStore, Store } from 'redux';

 import logger from 'redux-logger';
 
 import thunk from 'redux-thunk';
 
 import { definition, create, combine, StateOf } from 'redux-compact';
 import { setValueReducer } from 'redux-compact/plugins';
 
 import { RodzPokoiInfo, grafikOgolnyPokoje, PokojOpcja, Info, RezerwacjaPobyt, User, ObiectRoomNumer, ObiectRoomRodzaj, 
  webRoom, dostepnoscPokoju, WwwPortalInfo0, PokojeDostepne, Prefiks, Gosc,
  HasłoRezerwacja} from '../api';
 
 import i18n from '../cfg/i18n';
 import { NotifierData } from '../app/Notifier';
 import { daysFromDate, getBrowser, getSystem, sendFcmErrorLog } from '../app/common/helpers';
 
 import { MapData } from '../app/map/MapContainer';
import CONFIG from 'cfg/config';

 enum PanelState {
   psBrowse,
   psDetails,
   psUser,
   psCalendar,
   psReservPending
   /*  psSelect,
     psReservation,
     psCommit,
     psPayment*/
 }
 
 export type Navigator = {
   page: number;
   perPage: number;
   filter: string;
   order: string;
 }
 
 export type FcmMessage = {
   text: string;
   type: number;
 }
 
 export type ResBasketItem =
   {
     id: number,
     rodz_pokoi: string,
     name: string,
     price: number,
     quantity: number,
     cena_os1: number,
     cena_os2: number,
     cena_os3: number,
     cena_os4: number,
     ktora_cena: number,
     ilosc_miejsc: number,
     ilosc_dni_min: number
   };
 
   export type OpenReservation = {
    open: number;
    tel: string; 
    nr: number
  }
  
 
 // export type Contact ={
 //   email: string,
 //   phone : string,
 //   fax: string,
 //   address: string,
 //   gps: string
 // }
 
 export interface Values {
   name: string,
   surname: string,
   email: string,
   phone: string,
   remarks: string,

   dowod: string,
   adres: string,
   rodzice: string,
   dataUrodzenia: string,
   miejsceUrodzenia: string,
 }

 const initialValuesEmpty = {
  name: '',
  surname: '',
  email: '',
  phone: '',
  remarks: '',

  dowod: '',
  adres: '',
  rodzice: '',
  dataUrodzenia: '',
  miejsceUrodzenia: '',
};

 export type FormValues = {
  nip: string,
  nazwa: string,
  kod: string,
  miasto: string,
  ulica: string,
  info: string,
}

export type DaneNIP = {
  adres: string
  kontrNazwa: string,
  nip: string,
}

const initialDaneNIP = {
  adres: '',
  kontrNazwa: '',
  nip: '',
};

 export class ZapisanyFormularz {
   dostawca: string = '';
   pokoj: string = '';
   dataOd: string = '';
   dataDo: string = '';
   osob: number = 0;
 
   constructor(data?: any) {
     if (data) {
       this.dostawca = data.dostawca;
       this.pokoj = data.pokoj;
       this.dataOd = data.dataOd;
       this.dataDo = data.dataDo;
       this.osob = data.osob;
     }
   }
 }
 
 export interface IPageState {
   state: PanelState; // stan przeglądania
   dateFrom: string; // od dnia
   dateFromFormularz: string;
   dateTo: string; // do dnia
   dateToFormularz: string; // do dnia
   rooms: RodzPokoiInfo[]; // odczytane pokoje
   basket: RodzPokoiInfo[]; // koszyk rezerwacji
   roomsOld: webRoom[];
   basketOld: webRoom[];
   dostepnoscOld: dostepnoscPokoju[],
   navigator: Navigator; // nawigator - na przyszłość
   selectedRoom: string; // id. aktualnie wybanego pokoju
   lang: string; // język
   langPhone: { flag: string, prefix: string };
   theme: string,
   contact: Info;
   //contactManager: WwwPortalInfo0;
   options: PokojOpcja[];
   optionsValues: string[];
   formValues: FormValues;
   openOptions: number;
   openFormularzFaktura: number;
   grafik: grafikOgolnyPokoje[];
   podstrona: number;
   imageId: string;
   grafikNumery: ObiectRoomNumer[];
   grafikRodzaje: ObiectRoomRodzaj[];
   grafikRefresh: number;
   ilosc_dni_min: number;
   notifierOpen: number;
   platnosciOpen: number;
   dateMode: number;
   secondaryLight: string;
   secondaryText: string;
   czyPobytZmieniany: boolean;
   zmienianyPobyt: RezerwacjaPobyt;
   initialValues: Values;
   operators: User[];
   raportData: string;
   raportOkres: string;
   raportOperator: string;
   roomNumber: number;
   rezerwacjaAnuluj: number;
   graphicHighlight: string,
   kwota: number,
   numerRezerwacji: number,
   notifierData: NotifierData,
   browser: string,
   system: string,
   ip: string,
   fcmLogMessage: FcmMessage[],
   zapisanyFormularz: ZapisanyFormularz,
   formularzPicture: string,
   showMap: number,

   preautoryzacja: number,
   roomDetailsList: dostepnoscPokoju[],
   roomDetailsListNew: PokojeDostepne[],
   closeDialogZarzadzaj: number,
   daneNIP: DaneNIP,

   prefiksy: Prefiks[],
   czarnaLista: any[],
   sprawdzDostepnosc: boolean,

   map: MapData,
   windowTheme: string,
   openRezerwacjaZarzadzaj: OpenReservation,

   guest: Gosc,
   serwerWersja: number,
   grafikMode: number,
   ceny: dostepnoscPokoju[][],
   firstOpen: boolean,
   grafikMaxiMini: number,
   refreshCalendar: number,
   roomBlink: string,
   ustawPodstrona: boolean,

   rezerwacjaHaslo: HasłoRezerwacja,
 };
 
 
 function tomorrow(): Date {
   let d = new Date();
   d.setDate(d.getDate() + 1);
   return d;
 };
 function afterTomorrow(): Date {
   let d = new Date();
   d.setDate(d.getDate() + 2);
   return d;
 };
 
 export function minDaysLater(sDate: string, minDaysLater: number): string {
   let date = new Date(sDate);
   date.setDate(date.getDate() + minDaysLater);
   let mm = date.getMonth() + 1;
   let dd = date.getDate();
   let a = [date.getFullYear(), "-",
   (mm > 9 ? '' : '0') + mm, "-",
   (dd > 9 ? '' : '0') + dd
   ].join('');
   //dt.setDate(dt.getDate() + 1);
   //dt.setMonth(dt.getMonth());
   //dt.setFullYear(dt.getFullYear());
   return a;
 };
 
 function dateToString(sDate: Date): string {
   let mm = sDate.getMonth() + 1;
   let dd = sDate.getDate();
   let a = [sDate.getFullYear(), "-",
   (mm > 9 ? '' : '0') + mm, "-",
   (dd > 9 ? '' : '0') + dd
   ].join('');
 
   return a;
 };
 
 // function nextDay(sDate : string): string {
 //   let dt : Date = new Date(sDate);
 //   dt = new Date(dt.setDate(dt.getDate()+ 1));
 
 //   let mm = dt.getMonth() + 1;
 //   let dd = dt.getDate();
 //   return [dt.getFullYear(),"-",
 //           (mm>9 ? '' : '0') + mm,"-",
 //           (dd>9 ? '' : '0') + dd
 //         ].join('');
 //   /*dt.setDate(dt.getDate() + 1);
 //   dt.setMonth(dt.getMonth());
 //   dt.setFullYear(dt.getFullYear());
 //   return dt.toISOString().substring(0, 10);*/
 // };
 
 //type Dispatch = ReduxDispatch<IPageState>;

function setDateFromUrl(n: number): any {   // 1 - od  2 - do   3 - calendar

  const searchParams = new URLSearchParams(location.search);

  const dataStringOd = searchParams.get('dataOd');
  const dataStringDo = searchParams.get('dataDo');

  if (dataStringOd && dataStringDo) {
    let dataOd = new Date(dataStringOd)
    let dataDo = new Date(dataStringDo)
    let now = new Date()
    now.setHours(1)

    if (dataOd && dataOd.getTime() > now.getTime() &&
      dataDo && dataDo.getTime() > now.getTime()) {
      console.log(searchParams)
      console.log(dataOd, dataDo)

      switch (n) {
        case 1:
          return daysFromDate(dataOd, 0)
          break;
        case 2:
          return daysFromDate(dataDo, 0)
          break;
        case 3:
          return 1
          break;
        default:
          break;
      }
      //
      //store.dispatch(Actions.pageState.setDateTo(daysFromDate(dataDo, 0)));
      //store.dispatch(Actions.pageState.setDateFrom(daysFromDate(dataOd, 0), false));
      //store.dispatch(Actions.pageState.setFirstOpen());     
    }
  }
  return false
}

function setRoomBlink(): any {

  const searchParams = new URLSearchParams(location.search);

  const rodzPokoi = searchParams.get('rodzPokoi');

  

  if (rodzPokoi) { 

    setTimeout(() => {
      const roomElement = document.getElementById(rodzPokoi);
      if (roomElement) {
        const yOffset = -10; 
        const y = roomElement.getBoundingClientRect().top + window.scrollY + yOffset; 
        if(CONFIG.rodzPokoiPodstrona !== "1"){
          window.scrollTo({top: y, behavior: 'smooth'});
        }
        
        //roomElement.scrollIntoView({ behavior: "smooth" });
      }
    }, 2500);

      console.log(searchParams)
      console.log(rodzPokoi) 

      return rodzPokoi 
  }
  return false
}


 
 const pageState = definition<IPageState>()
   .setDefault(
     {
       state: PanelState.psBrowse,
       dateFrom: setDateFromUrl(1) ? setDateFromUrl(1) : dateToString(new Date()),
       dateFromFormularz: setDateFromUrl(1) ? setDateFromUrl(1) : dateToString(new Date()),
       /*      dateTo :  (
               new Date().getDate() + 1
             ).toString().substring(0, 10),*/
       dateTo: setDateFromUrl(2) ? setDateFromUrl(2) : dateToString(tomorrow()),
       dateToFormularz: setDateFromUrl(2) ? setDateFromUrl(2) : dateToString(tomorrow()),
       rooms: [],
       //      reservations : [],
       basket: [],
       navigator: {
         page: 1,
         perPage: 5,
         filter: '',
         order: ''
       },
       roomsOld: [],
       basketOld: [],
       dostepnoscOld: [],
       selectedRoom: ' - nic nie wybrano - ',
       lang: 'pl',
       langPhone: { flag: 'pl', prefix: "48" },
       contact: new Info(),
       //contactManager: new WwwPortalInfo0(),
       options: [],
       optionsValues: ["0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0"],
       formValues: {nip: '', nazwa: '', kod: '', miasto: '', ulica: '', info: ''},
       openOptions: 0,
       openFormularzFaktura: 0,
       theme: "0",
       grafik: [],
       podstrona: 0,
       imageId: "",
       grafikNumery: [],
       grafikRodzaje: [],
       grafikRefresh: 0,
       ilosc_dni_min: 1,
       notifierOpen: 0,
       platnosciOpen: 0,
       dateMode: 0,
       secondaryLight: '',
       secondaryText: '',
       czyPobytZmieniany: false,
       zmienianyPobyt: new RezerwacjaPobyt(),
       initialValues: initialValuesEmpty,
       operators: [],
       raportData: "6",
       raportOkres: "3",
       raportOperator: "",
       roomNumber: 0,
       rezerwacjaAnuluj: 0,
       graphicHighlight: "",
       kwota: 0,
       numerRezerwacji: 0,
       notifierData: new NotifierData(),
       browser: getBrowser(),
       system: getSystem(),
       ip: "",
       fcmLogMessage: [],
       zapisanyFormularz: new ZapisanyFormularz(),
       formularzPicture: '',
       showMap: 0,

       preautoryzacja: 0,
       roomDetailsList: [],
       roomDetailsListNew: [],
       closeDialogZarzadzaj: 0,
       daneNIP: initialDaneNIP,

       prefiksy: [],
       czarnaLista: [],
       sprawdzDostepnosc: true,

       map: new MapData(),
       windowTheme: "1",

       openRezerwacjaZarzadzaj: {open: 0, tel: "", nr: 0},
       guest: new Gosc(),
       serwerWersja: 1,
       grafikMode: 0,
       ceny: [],
       firstOpen: setDateFromUrl(3) === 1 ? false : true,
       grafikMaxiMini: 1,
       refreshCalendar: 0,
       roomBlink: setRoomBlink() ? setRoomBlink() : "",
       ustawPodstrona: true,

       rezerwacjaHaslo: new HasłoRezerwacja(),
     })
   .addReducers({
     setUser: (pageState: IPageState) => ({ ...pageState, completed: true }),
     setPanelState: (pageState: IPageState, newState: PanelState) =>
       ({ ...pageState, state: newState }),
     restart: (pageState: IPageState) =>
       ({ ...pageState, basket: [], basketOld: [], state: PanelState.psBrowse }),
     setDateFrom: (pageState: IPageState, date: string, refreshGrafik: boolean = false) => {
      
       if (date == pageState.dateFrom && !refreshGrafik) return pageState
       else if (date == pageState.dateFrom) return ({
        ...pageState, grafikRefresh: pageState.grafikRefresh +1
      })
       else {
         let date2: string = minDaysLater(date, pageState.ilosc_dni_min);
         return ({
           ...pageState, basket: [], basketOld: [], dateFrom: date, //dateTo: date2
         })
       }
     },
     setDateTo: (pageState: IPageState, date: string) => {
       //if (date == pageState.dateTo) return pageState
       //else return ({ ...pageState, basket: [], basketOld: [], dateTo: date })
       return ({ ...pageState,  dateTo: date })
     },
     setDateFromFormularz: (pageState: IPageState, date: string) => {
       if (date == pageState.dateFromFormularz) return pageState
       else return ({ ...pageState, basket: [], basketOld: [], dateFromFormularz: date })
     },
     setDateToFormularz: (pageState: IPageState, date: string) => {
       if (date == pageState.dateToFormularz) return pageState
       else return ({ ...pageState, basket: [], basketOld: [], dateToFormularz: date })
     },
     setContact: (
       pageState: IPageState, contact: Info,
       secondaryLight: string,
       secondaryText: string
     ) =>
     ({
       ...pageState,
       contact: contact, theme: contact.materialuiZestawNr,
       secondaryLight: secondaryLight,
       secondaryText: secondaryText,
     }),
    //  setContactManager: (pageState: IPageState, contact: WwwPortalInfo0) =>
    //  ({ ...pageState, contactManager: contact }),
     setOptions: (pageState: IPageState, options: PokojOpcja[]) =>
       ({ ...pageState, options: options }),
     setOptionsValues: (pageState: IPageState, optionsVal: string[]) =>
       ({ ...pageState, optionsValues: optionsVal }),
     changeOpenOptions: (pageState: IPageState) =>
       ({ ...pageState, openOptions: pageState.openOptions + 1 }),
     changeOpenFormularzFaktura: (pageState: IPageState) =>
       ({ ...pageState, openFormularzFaktura: pageState.openFormularzFaktura + 1 }),
     selectRoom: (pageState: IPageState,
       newState: PanelState, roomId: string = '') =>
     ({
       ...pageState, state: newState,
       selectedRoom: roomId
     }),
     updateRooms: (pageState: IPageState, newRooms: RodzPokoiInfo[]) => {
       return ({ ...pageState, rooms: newRooms })
     },
     updateGrafik: (pageState: IPageState, newGrafik: grafikOgolnyPokoje[]) => {
       return ({ ...pageState, grafik: newGrafik })
     },
     /*
         newReservation : (pageState: IPageState, 
                       newState : PanelState, res  : Reservation) => 
                       { 
                         let newList = pageState.reservations
                         newList.push(res)
                         let newBasket = pageState.basket
                         newBasket.push({
                             id: res.id,
                             name: res.info, 
                             price: res.price,
                             quantity: 1        
                         })
                         return ({...pageState, state: newState,
                           reservations : newList,
                           basket: newBasket
                         })
                       },
                       */
     updateBasket: (pageState: IPageState, newBasket: RodzPokoiInfo) =>
       ({ ...pageState, basket: [newBasket] }),
     setLang: (pageState: IPageState, lang: string) => {
       i18n.changeLanguage(lang)
       //          alert(pageState.lang+'->'+i18n.language)
       //          alert(JSON.stringify(i18n.languages))
       return ({ ...pageState, lang: lang, langPhone: { flag: lang, prefix: '' } })
     },
     // setTheme: (pageState: IPageState, theme : string) => 
     //   ({...pageState, theme : theme}),   
     setLangPhone: (pageState: IPageState, obj: { flag: string, prefix: string }) =>
       ({ ...pageState, langPhone: obj }),
     setIloscDniMin: (pageState: IPageState, new_ilosc_dni_min: number) =>
       ({ ...pageState, ilosc_dni_min: new_ilosc_dni_min }),
     setNotifierOpen: (pageState: IPageState) =>
       ({ ...pageState, notifierOpen: pageState.notifierOpen + 1 }),
     setNotifierData: (pageState: IPageState, data: NotifierData) =>
       ({ ...pageState, notifierData: data }),
     setPlatnosciOpen: (pageState: IPageState, n: number, numerRezerwacji: number) =>
       ({ ...pageState, platnosciOpen: pageState.platnosciOpen + 1, kwota: n, numerRezerwacji: numerRezerwacji }),
     setDateMode: (pageState: IPageState) =>
       ({ ...pageState, dateMode: pageState.dateMode + 1 }),
     setCzyPobytZmieniany: (pageState: IPageState, nowyCzyPobytZmieniany: boolean) =>
       ({ ...pageState, czyPobytZmieniany: nowyCzyPobytZmieniany }),
     setZmienianyPobyt: (pageState: IPageState, nowyZmienianyPobyt: RezerwacjaPobyt) =>
     ({
       ...pageState,
       zmienianyPobyt: nowyZmienianyPobyt,
       initialValues: {
         name: nowyZmienianyPobyt.gosc_nazwisko,
         surname: '',
         email: nowyZmienianyPobyt.gosc_e_mail,
         phone: nowyZmienianyPobyt.gosc_telefon,
         remarks: nowyZmienianyPobyt.notes_tresc,
         dowod: '',
         adres: '',
         rodzice: '',
         dataUrodzenia: '',
         miejsceUrodzenia: '',
       }
     }),
     resetZmienianyPobyt: (pageState: IPageState) =>
       ({ ...pageState, zmienianyPobyt: new RezerwacjaPobyt(), initialValues: initialValuesEmpty }),
     setRaportData: (pageState: IPageState, data: string) =>
       ({ ...pageState, raportData: data }),
     setRaportOkres: (pageState: IPageState, okres: string) =>
       ({ ...pageState, raportOkres: okres }),
     setRaportOperator: (pageState: IPageState, operator: string) =>
       ({ ...pageState, raportOperator: operator }),
     updateGrafikNumery: (pageState: IPageState, newGrafik: ObiectRoomNumer[]) => {
       return ({ ...pageState, grafikNumery: newGrafik })
     },
     updateGrafikRodzaje: (pageState: IPageState, newGrafik: ObiectRoomRodzaj[]) => {
       return ({ ...pageState, grafikRodzaje: newGrafik })
     },
     setGrafikRefresh: (pageState: IPageState) =>
      ({ ...pageState, grafikRefresh: pageState.grafikRefresh +1 }),
     setRoomNumber: (pageState: IPageState, n: number) =>
       ({ ...pageState, roomNumber: n }),
     updateBasketOld: (pageState: IPageState, newBasket: webRoom) =>
       ({ ...pageState, basketOld: [newBasket] }),
     updateRoomsOld: (pageState: IPageState, newRooms: webRoom[]) => {
       return ({ ...pageState, roomsOld: newRooms })
     },
     setDostepnoscOld: (pageState: IPageState, dost: dostepnoscPokoju[]) =>
       ({ ...pageState, dostepnoscOld: dost }),
     setRezerwacjaAnuluj: (pageState: IPageState, rez: number) =>
       ({ ...pageState, rezerwacjaAnuluj: rez }),
     setGraphicHighlight: (pageState: IPageState, highlihgt: string) =>
       ({ ...pageState, graphicHighlight: highlihgt }),
     setIp: (pageState: IPageState, ip: string) =>
       ({ ...pageState, ip: ip }),
     addFcmLogMessage: (pageState: IPageState, text: string, type: number) => {
       let log = pageState.fcmLogMessage
       log.push({ text: text, type: type })
       if (log.length >= 5 || type === 2) {
         sendFcmErrorLog(log)
         return ({ ...pageState, fcmLogMessage: [] })
       }
       return ({ ...pageState, fcmLogMessage: log })
     },
     handleCloseWithoutModal: (pageState: IPageState, obj: { flag: string, prefix: string }) =>
     ({
       ...pageState,
       zmienianyPobyt: new RezerwacjaPobyt(),
       initialValues: initialValuesEmpty,
       czyPobytZmieniany: false,
       langPhone: obj,
       state: PanelState.psBrowse,
       zapisanyFormularz: new ZapisanyFormularz(),
       formularzPicture: ''
     }),
     handleClose: (pageState: IPageState, obj: { flag: string, prefix: string }) =>
     ({
       ...pageState,
       langPhone: obj,
       zapisanyFormularz: new ZapisanyFormularz(),
       formularzPicture: ''
     }),
     setZapisanyFormularzAndInitialValues: (pageState: IPageState, aZapisanyFormularz: ZapisanyFormularz, aInitialValues: Values, aFormularzPicture: string) =>
       ({ ...pageState, zapisanyFormularz: aZapisanyFormularz, initialValues: aInitialValues, formularzPicture: aFormularzPicture }),
     reserve0WithDateFromFormularz: (pageState: IPageState, highlihgt: string, aDateFromFormularz: string, aDateTo: string) =>
       ({ ...pageState, graphicHighlight: highlihgt, basket: [], basketOld: [], dateFromFormularz: aDateFromFormularz, dateToFormularz: aDateTo, state: PanelState.psBrowse }),
     reserve0: (pageState: IPageState, highlihgt: string, aDateTo: string) =>
       ({ ...pageState, graphicHighlight: highlihgt, basket: [], basketOld: [], dateToFormularz: aDateTo, state: PanelState.psBrowse }),
     reserve1or2WithDateFromFormularz: (pageState: IPageState, highlihgt: string, aDateFromFormularz: string, aDateTo: string, n: number) =>
       ({ ...pageState, graphicHighlight: highlihgt, basket: [], basketOld: [], dateFromFormularz: aDateFromFormularz, dateToFormularz: aDateTo, state: PanelState.psBrowse, roomNumber: n }),
     reserve1or2: (pageState: IPageState, highlihgt: string, aDateTo: string, n: number) =>
       ({ ...pageState, graphicHighlight: highlihgt, basket: [], basketOld: [], dateToFormularz: aDateTo, state: PanelState.psBrowse, roomNumber: n }),
     setShowMap: (pageState: IPageState) =>
       ({ ...pageState, showMap: pageState.showMap + 1 }),
     setPreautoryzacja: (pageState: IPageState, num: number) =>
       ({ ...pageState, preautoryzacja: num }),
      setRoomDetailsList: (pageState: IPageState, list: dostepnoscPokoju[]) =>
       ({ ...pageState, roomDetailsList: list }),
      setRoomDetailsListNew: (pageState: IPageState, list: PokojeDostepne[]) =>
       ({ ...pageState, roomDetailsListNew: list }),
      closeDialogZarzadzaj: (pageState: IPageState, ) =>
       ({ ...pageState, closeDialogZarzadzaj: pageState.closeDialogZarzadzaj + 1  }),
      setDaneNIP: (pageState: IPageState, data: DaneNIP) =>
       ({ ...pageState, daneNIP: data }),
      clearDaneNIP: (pageState: IPageState) =>
       ({ ...pageState, daneNIP: {nip: '', adres: '', kontrNazwa: ''} }),
      setPodstrona: (pageState: IPageState, podstrona: number, imageId: string) =>
       ({ ...pageState, podstrona: podstrona, imageId: imageId, ustawPodstrona: false }),
      setPrefiksy: (pageState: IPageState, p: Prefiks[]) =>
       ({ ...pageState, prefiksy: p }),
      setCzarnaLista: (pageState: IPageState, lista: any[]) =>
       ({ ...pageState, czarnaLista: lista }),
      setSprawdzDostepnosc: (pageState: IPageState, dost: boolean) =>
       ({ ...pageState, sprawdzDostepnosc: dost }),
      setOpenRezerwacjaZarzadzaj: (pageState: IPageState, res: any) => {
        let r: OpenReservation = {open: pageState.openRezerwacjaZarzadzaj.open +1, tel: res.tel, nr: res.nr}
        return ({ ...pageState, openRezerwacjaZarzadzaj: r })
      },
      setGuest: (pageState: IPageState, guest: Gosc) =>
      ({ ...pageState, guest: guest }),
      setSerwerWersja: (pageState: IPageState, wersja: string) => {
        let w = Number(wersja.split(".")[0])

        return ({ ...pageState, serwerWersja: w, grafikMode: w >= 5 ? 1 : 0 })
      },
      //({ ...pageState, serwerWersja: 1 }),
      setGrafikMode: (pageState: IPageState, wersja: number) =>
      ({ ...pageState, grafikMode: wersja }),
      setCeny: (pageState: IPageState, ceny: dostepnoscPokoju[], rodzaj: number) => {
        let c = pageState.ceny
        c[rodzaj] = ceny

        return ({ ...pageState, ceny: c })
      },

      setFirstOpen: (pageState: IPageState) =>
        ({ ...pageState, firstOpen: false }),
      setGrafikMaxiMini: (pageState: IPageState, mode: number) =>
        ({ ...pageState, grafikMaxiMini: mode }), 
      setRefreshCalendar: (pageState: IPageState,) =>
        ({ ...pageState, refreshCalendar: pageState.refreshCalendar + 1 }),
      
       
       setMap: (pageState: IPageState, data: MapData, reset: boolean = false) => {
        let prevMap = pageState.map
        let d = new MapData({
          obiektGPS: data.obiektGPS || prevMap.obiektGPS,
          obiektLat: data.obiektLat || prevMap.obiektLat,
          obiektLng: data.obiektLng || prevMap.obiektLng,
          klientAdres: data.klientAdres || prevMap.klientAdres,
          klientGPS: data.klientGPS || prevMap.klientGPS,
          klientLat: data.klientLat || prevMap.klientLat,
          klientLng: data.klientLng || prevMap.klientLng,
          dokNr: data.dokNr || prevMap.dokNr,
        })

        if(reset){
          d = new MapData({
            obiektGPS: data.obiektGPS === undefined ? prevMap.obiektGPS : data.obiektGPS,
            obiektLat: data.obiektLat === undefined ? prevMap.obiektLat : data.obiektLat,
            obiektLng: data.obiektLng === undefined ? prevMap.obiektLng : data.obiektLng,
            klientAdres: data.klientAdres === undefined ? prevMap.klientAdres : data.klientAdres,
            klientGPS: data.klientGPS === undefined ? prevMap.klientGPS : data.klientGPS,
            klientLat: data.klientLat === undefined ? prevMap.klientLat : data.klientLat,
            klientLng: data.klientLng === undefined ? prevMap.klientLng : data.klientLng,
            dokNr: data.dokNr === undefined ? prevMap.dokNr : data.dokNr,
          })
        }

        return ({ ...pageState, map: d })
      },

      setRezerwacjaHasla: (pageState: IPageState, haslo: HasłoRezerwacja) =>{
        return ({ ...pageState, rezerwacjaHaslo: haslo })
      },
      });
 
 /*
 const pageStates = list({ of: pageState, key: pageState  => pageState.id}).addReducers({
     add: (pageStates: PageState[], pageState: PageState) => [...pageStates, pageState]
 });
 */
 
 const auth = definition<string | undefined>().
   setDefault(window.localStorage.getItem('accessToken') || undefined).
   use(setValueReducer).addActionCreators({
     login: function (accessToken: string) {
       window.localStorage.setItem('accessToken', accessToken);
       return this.setValue(accessToken);
     },
     logout: function () {
       window.localStorage.removeItem('accessToken');
       return this.setValue(undefined)
     }
   });
 
 
 const appState = combine({
   auth,
   pageState
 });
 
 const { Actions, reduce } = create(appState);
 export type AppState = StateOf<typeof appState>;
 
 export const store: Store<AppState> = createStore(reduce,
   applyMiddleware(thunk, logger),
 );
 
 export { Actions, PanelState };
 